import React from "react";

export const Features = (props) => {
  return (
      <div id="features" className="text-center" style={{
          maxWidth: "100%",
          overflow: "hidden",
          display: "flex",
          flexWrap: "wrap",
          justifyContent: "center"
      }}>
          <div className="container">
              <div className="col-md-10 col-md-offset-1 section-title">
                  <h2>Funzionalità</h2>
              </div>
              <div className="row d-flex flex-wrap justify-content-center">
                  {props.data
                      ? props.data.map((d, i) => (
                          <div
                              key={`${d.title}-${i}`}
                              className="col-12 col-sm-6 col-md-4 col-lg-3 d-flex flex-column align-items-center text-center"
                              style={{ padding: "20px" }}
                          >
                              <i className={d.icon} style={{ fontSize: "40px", marginBottom: "10px" }}></i>
                              <h3>{d.title}</h3>
                              <p>{d.text}</p>
                          </div>
                      ))
                      : "Loading..."}
              </div>
          </div>
      </div>

  );
};
